import { Props } from '../../native';
import Comment from '../../../sub/comment';
import * as React from 'react';
import { NativeTransparencyButton } from '../../parts/native-transparency-button';
import { NativeLogo } from '../../parts/native-logo';
import Description from '../../../sub/description';
import { NativeTopLeftLabel } from '../../parts/native-top-left-label';
import { NativeTitleWithAnchor } from '../../parts/native-title-with-anchor';
import { getImageSizes, NativeImage } from '../../parts/native-image';

export function ResultBapAd(props: Props) {
    const { id, adObj, deviceType, grid, accessibilityId } = props;
    const { native } = adObj;
    const mobile = deviceType === 'mobile';
    const list = !grid && !mobile;

    return (
        <div
            id={id}
            className={'ads__unit ads__unit--native'}
            aria-owns={accessibilityId}
        >
            <Comment placement="ResultBapAd" adObj={adObj} />
            <div className={'relative ads__unit__img'}>
                <NativeImage
                    aspectClass={`ads__unit__img__ratio img-format img-format--centered ${
                        list ? 'img-format--ratio3by2' : 'img-format--ratio4by3'
                    }`}
                    imageClass={'img-format__img h-full w-full object-cover'}
                    imageSizes={getImageSizes(list ? 'list' : 'grid', 'bap')}
                    native={native}
                />
                <NativeTopLeftLabel radiusClass={'rounded-br-8 rounded-tl-8'} />
            </div>

            <div className={'ads__unit__content font-normal'}>
                <div
                    className={`flex flex-row justify-between text-12 items-center`}
                >
                    <div
                        className={`text-14 text-gray-500 flex ${
                            list ? 'flex-row mb-4' : 'flex-col'
                        } gap-8`}
                    >
                        {native.sponsoredBy}
                    </div>
                </div>
                <div className={'pb-48 flex flex-row items-end gap-4'}>
                    <div className={`flex flex-col`}>
                        <NativeTitleWithAnchor
                            className={'text-16 font-normal'}
                            native={native}
                            accessibilityId={accessibilityId}
                        />

                        <Description native={native} className="text-12" />
                    </div>
                    <div className={'absolute bottom-8 right-8'}>
                        <NativeLogo native={native} />
                    </div>
                </div>
            </div>
            <NativeTransparencyButton
                adObj={adObj}
                className={!list ? '' : 'top-8 right-8'}
            />
        </div>
    );
}
